<template>
  <header class="header">
    <div class="header__main">
      <button id="tooltip-button-1" class="header__button" v-on:click="showProducts()">
        <img src="../assets/images/icon__products.svg" alt="icon__products" />
      </button>
      <b-tooltip :show.sync="showTipProducts" target="tooltip-button-1" variant="warning" placement="top">
        <span v-html="tipProducts[$props.lang]"></span>
      </b-tooltip>
      <a href="#" target="_self" class="navbar-brand font-weight-bold ml-1 text-white">
        <img :src="$props.logo" height="25px;" alt="" class="d-inline-block align-top">
        {{$props.name}}
        <small style="font-size:12px" class="font-weight-light">by <b>Systemico</b>.</small>
      </a>
      <button class="header__menu" @click="showMenu()">
        <b-icon icon="list"></b-icon>
      </button>
      <div class="header__nav">
        <div class="translate">
          <button class="btn-translate" v-on:click="showTranslate()">
            <b-icon icon="globe"></b-icon>
            <span v-if="language">{{ language }}</span>
          </button>

          <div
            class="options-translate"
            v-show="stateTranslate"
            @mouseleave="closeTranslate()"
          >
            <a
              @click="changeLanguage('EN')"
              href="#select-lang-english"
              rel="noopener noreferrer"
              id="select-lang-english"
              >English</a
            >
            <a
              @click="changeLanguage('ES')"
              href="#select-lang-spanish"
              rel="noopener noreferrer"
              id="select-lang-spanish"
              >Español</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="header__products" v-if="products">
      <header>
        <h3>Products</h3>
        <p>Cool solutions to improve your processes.</p>
      </header>
      <nav>
        <a
          href="https://pradek.co/suppmail/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-suppmail.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Suppmail
        </a>
        <a
          href="https://systemico.net/products/wabot/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-wabot.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Wabot</a
        >
        <a
          href="https://systemico.net/products/pugobox/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-pugobox.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Pugobox</a
        >
        <a
          href="https://systemico.net/products/grumpyturtle/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-grumpyturtle.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Grumpyturtle</a
        >
        <a
          href="https://systemico.net/products/chatter/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-chatter.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Chatter</a
        >
        <a
          href="https://systemico.net/products/penguinstrategy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-penguin.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Penguin Strategy</a
        >
        <a
          href="https://systemico.net/products/focusmeet/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-focusmeet.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Focusmeet</a
        >
        <a
          href="https://systemico.net/products/ducksites/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-ducksite.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Ducksites</a
        >
        <a
          href="https://systemico.net/products/provedur/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-provedur.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Provedur</a
        >
        <a
          href="https://systemico.net/products/transpur/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="$cdnSystemico + 'icons/products/icon-transpur.svg'"
            alt="logotipo systemico"
            title="systemico 😊"
          />
          Transpur</a
        >
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "headerC",
  data: function () {
    return {
      language: '',
      stateTranslate: false,
      products: false,
      showTipProducts: true,
      tipProducts: {
        ES: 'Más soluciones de <strong>software innovador</strong> para tu negocio.',
        EN: 'More <strong>innovative software</strong> solutions for your business.',
        FR: 'Plus de <strong>logiciels innovants</strong> pour votre entreprise.'
      }
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: true
    }
  },
  beforeMount() {
    this.language = this.lang
  },
  mounted() {
    /**let language = localStorage.getItem("userLanguage");
    if (language == null || language ==="ES") {
      this.language = this.lang;
    } else {
      this.language = localStorage.getItem("userLanguage");
    }**/
  },
  methods: {
    showTranslate: function () {
      this.stateTranslate = true;
    },
    closeTranslate: function () {
      this.stateTranslate = false;
    },
    changeLanguage: function (idioma) {
      this.language = idioma
      this.$emit('changeLang', idioma)
    },
    showProducts: function () {
      this.products = !this.products
      this.showTipProducts = false
    }
  }
}
</script>

<style lang="scss">
.header {
  position: sticky;
  top: 0;
  z-index: 100;

  &__main {
    padding: 0.5rem;
    background-color: #171e44;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__button {
    width: 20px;
    min-width: 20px;
    height: 20px;
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__menu {
    width: 20px;
    min-width: 20px;
    height: 20px;
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;

    svg {
      color: white;
      font-size: 20px;
    }
  }

  &__nav {
    margin-left: auto;
  }

  &__products {
    width: 100%;
    height: 100%;
    min-height: 100%;
    overflow-y: auto;
    border-right: 3px solid #aaaaaa;
    background-color: white;
    position: fixed;
    left: 0;
    padding: 0;

    header {
      padding: 20px 25px;
      background-color: white;

      h3 {
        margin: 0 0 5px;
        font-family: "Mulish", sans-serif;
        font-size: 22px;
        font-weight: 500;
        color: #313541;
        line-height: 1;
      }
      p {
        margin: 0;
        font-family: "Mulish", sans-serif;
        font-size: 12px;
        font-weight: 400;
        color: #313541;
        line-height: 1;
      }
    }

    nav {
      height: calc(100vh - 150px);
      padding: 0 25px 20px;
      overflow: auto;

      a {
        width: 100%;
        margin: 0 0 10px;
        padding: 20px;
        border: 1px solid #d1d5e9;
        border-radius: 5px;
        background-color: white;
        font-family: "Mulish", sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: #171e44;
        line-height: 1;
        display: flex;
        align-items: center;

        &:hover {
          border-color: #1c78e6;
          font-weight: 400;
          text-decoration: none;
        }

        img {
          width: 22px;
          margin: 0 10px 0 0;
          display: block;
        }
      }
    }
  }

  @media (min-width: 768px) {
    &__products {
      width: 265px;

      nav {
        height: calc(100vh - 189px);
      }
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    justify-content: inherit;

    &__button {
      margin-right: 20px;
    }

    &__menu {
      display: none;
    }
  }
}

.translate {
  margin-right: 20px;
  position: relative;

  // &.show {
  //   .btn-translate {
  //     svg {
  //       color: #ff8028;
  //     }
  //   }
  // }

  // &.show {
  //   .options-translate {
  //     height: auto;
  //   }
  // }
}

.btn-translate {
  width: 30px;
  min-width: 30px;
  height: 30px;
  margin: 0 auto;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    font-size: 20px;
    color: white;
    pointer-events: none;
  }

  span {
    padding: 0 4px;
    border-radius: 30px;
    background-color: white;
    font-family: "Mulish", sans-serif;
    font-size: 10px;
    font-weight: bold;
    color: #171e44;
    text-align: center;
    text-transform: uppercase;
    position: absolute;
    top: 15px;
    left: 15px;
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
  }
}

.options-translate {
  overflow: hidden;

  a {
    margin: 20px 0;
    font-family: "Quicksand", sans-serif;
    font-size: 13px;
    font-weight: bold;
    color: #ffffff;
    line-height: 15px;
    text-align: center;
    display: block;
    text-transform: uppercase;
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    min-width: 110px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px #4d576f29;
    position: absolute;
    top: 30px;
    right: 0;
    z-index: 15;

    a {
      margin: 0;
      padding: 10px;
      font-family: "Mulish", sans-serif;
      font-size: 14px;
      font-weight: lighter;
      color: #171e44 !important;
      line-height: 15px;
      text-align: left;
      display: block;
      text-transform: none;

      &:hover {
        text-decoration: none;
        background-color: #e9ecf4;
      }
    }
  }
}
</style>
